import {
  Box,
  Heading,
  Stack,
  useColorModeValue as mode,
} from '@chakra-ui/react'
import * as React from 'react'
import styled from 'styled-components'
import device from './device'
import Accordion from './Accordion'

const Faq = ({ price, className }) => {
  return (
    <div className={className}>
      <a id="faq" />
      <div className="wrapper">
        <h2>Frequently Asked Questions</h2>
        <div className="content">
          <Stack direction={{ base:'column', md:'row' }} spacing={{ base:'32px', md:'100px' }}>
            <Box width={{ base:'100%', md:'50%' }}>
              <Heading
                as="h3"
                fontFamily="Tomato Grotesk"
                color="blue.600"
                fontSize="2em"
              >
                Financing & Payment
              </Heading>
              <Accordion
                title="What is the cost of the training?"
                content={`The is a part-time online course that can be done entirely from your home or office. The price is ${price} € tax included.`}
              />
              <Accordion
                title="Can I pay by installments?"
                content={`Yes, we are flexible with the payment plans. Please contact us via the chat to discuss the payment options we have available.`}
              />
              <Accordion
                title="Can the training be financed by the French CPF?"
                content={`It’s with great pleasure that we announce Jungle Program is an official CPF-Eligible training.`}
              />
              <Accordion
                title="Is there a free trial period?"
                content={`Yes. Take a free 5-day trial. You will not pay anything unless you decide to continue.`}
              />
            </Box>
            <Box width={{ base:'100%', md:'50%' }}>
              <Heading
                as="h3"
                fontFamily="Tomato Grotesk"
                color="blue.600"
                fontSize="2em"
              >
                Course
              </Heading>
              <Accordion
                title="How long is the training, what's the schedule?"
                content={`You will take part in a 1.5-hour course, every Monday and Wednesday, and receive the full support of our expert trainer. You will experience a total of 36 hours of training including 18 hours of hands-on coaching with our expert professors.`}
              />
              <Accordion
                title="I have a full-time job. Can I attend the training?"
                content={`Yes, our online courses are created for anyone with a full-time job. You can take your training in your spare time.`}
              />
              <Accordion
                title="Do you offer job follow-up?"
                content={`We offer you the mentorship you need to take your career to the next level. We’ll stay in touch and guide you throughout your career, no matter where it takes you.`}
              />
              <Accordion
                title="How will I be assessed?"
                content={`Every week, you’ll be given a set of hands-on homework assignments that will guide your growth. You will have the opportunity to show your skills, knowledge and expertise through exercices, a final project, and an evaluation by our team of teachers. Upon completion, you will become a Jungle Program Certified Data Scientist.`}
              />
            </Box>
          </Stack>
        </div>
      </div>
    </div>
  )
}

const StyledFaq = styled(Faq)`
  width: 100%;

  .wrapper {
    max-width: 1920px;
    margin: 0 auto;
    padding-top: 20px;
  }

  .content {
    width: 100%;
    max-width: 1100px;
    margin: 0 auto 50px auto;
    padding: 0 25px 32px;
    box-sizing: border-box;

    @media ${device.laptop} {
      padding: 0 25px 40px;
      flex-direction: row;
    }
  }

  h2 {
    font-family: 'Tomato Grotesk';
    font-weight: 600;
    color: #000000;
    font-size: 34px;
    letter-spacing: 0.25px;
    text-align: center;
    padding: 25px 0;

    @media ${device.tablet} {
      padding: 44px 0;
      font-size: 44px;
    }
  }
`

export default StyledFaq